"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextTrigger = void 0;
var tslib_1 = require("tslib");
var DEFAULT_TRIGGER = /(.*)/;
var DEFAULT_POST_SELECT_WRAPPER = function (suggestion) { return suggestion; };
var ContextTrigger = /** @class */ (function () {
    function ContextTrigger(contexts) {
        this.contexts = contexts;
    }
    /* Example: match('value(myVar1') */
    ContextTrigger.prototype.match = function (value) {
        var e_1, _a;
        var _loop_1 = function (context_1) {
            var 
            /* Example: /value\((\S*)(?!.*value\()/ - Last open value() */
            _d = context_1.trigger, 
            /* Example: /value\((\S*)(?!.*value\()/ - Last open value() */
            trigger = _d === void 0 ? DEFAULT_TRIGGER : _d, 
            /* Example: ['myVar11', 'myVar12', 'myVar21'] - Variable names */
            suggestions = context_1.suggestions, 
            /* Example: (suggestion: string) => `value(${suggestion})` - Wrap in value() */
            _e = context_1.postWrapper, 
            /* Example: (suggestion: string) => `value(${suggestion})` - Wrap in value() */
            postWrapper = _e === void 0 ? DEFAULT_POST_SELECT_WRAPPER : _e, title = context_1.title;
            /* Example: ['value(myVar1', 'myVar1', index: 0, input: 'value(myVar1'] */
            var contextMatch = value.match(trigger);
            if (!contextMatch) {
                return "continue";
            }
            /* Example: 'my' */
            var valueRest = contextMatch[1] !== undefined ? contextMatch[1] : value;
            /* Example: ['myVar11', 'myVar12'] */
            var filteredSuggestions = suggestions.filter(function (suggestion) { return !!~suggestion.indexOf(valueRest); });
            if (filteredSuggestions.length) {
                return { value: {
                        suggestions: filteredSuggestions,
                        wrapper: function (suggestion) { return value.replace(trigger, postWrapper(suggestion)); },
                        title: title,
                    } };
            }
        };
        try {
            for (var _b = tslib_1.__values(this.contexts), _c = _b.next(); !_c.done; _c = _b.next()) {
                var context_1 = _c.value;
                var state_1 = _loop_1(context_1);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return null;
    };
    return ContextTrigger;
}());
exports.ContextTrigger = ContextTrigger;
//# sourceMappingURL=context-trigger.js.map